<ng-container>
  <div class="wrapper__body">
    <div class="wrapper__body__content">
      <div [ngClass]="{ 'is-hidden': isLoading }">
        <roma-deals [customer]="customer" [showCalendar]="false"></roma-deals>
      </div>
    </div>
  </div>
</ng-container>
